import React, { useState } from 'react';
import { Tooltip } from '@material-ui/core';

import { getUserInfo, isAdmin } from '@/utils/Util';

const OrderDetailsTabs = ({
	type,
	currentStep,
	isDrafted,
	orderPlaceMentStatus,
	orderCancelInfo,
	onChangeStep
}) => {
	const userInfo = getUserInfo();
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const alwaysExcludedSteps = ['SALES_CONTRACT', 'COMMERCIAL_INVOICE', 'PAYMENT_TRACKER'];
	const adminDropdownSteps = ['COMMERCIAL_INVOICE', 'PAYMENT_TRACKER'];
	const adminDropdownItems = orderPlaceMentStatus?.filter((item) =>
		adminDropdownSteps.includes(item.workflowStep)
	);
	const orderPlacementStatusList = (
		type === 'PENDING'
			? orderPlaceMentStatus.filter(
					(item) => !['COMMERCIAL_INVOICE', 'PAYMENT_TRACKER'].includes(item.workflowStep)
				)
			: orderPlaceMentStatus
					.filter((item) => {
						if (item.workflowStep === 'TEAM') {
							return userInfo.userLevelName === 'Software Engineer';
						}
						return true;
					})
					.filter((item) => {
						if (orderCancelInfo.status === 'APPROVED') {
							return ['ORDER_INFO'].includes(item.workflowStep);
						} else {
							return true;
						}
					})
	).filter((item) => !alwaysExcludedSteps.includes(item.workflowStep));
	return (
		<>
			{!isDrafted && (
				<div className="order-details-sidebar orderer-details-pending-sidebar d-flex align-items-center">
					<ul className="d-flex tab-list-items flex-wrap">
						{orderPlacementStatusList?.map((item) => (
							<li
								key={item.workflowStep}
								className={`d-flex align-items-center align-self-center ${currentStep === item.stepName ? 'selected' : ''}`}
								onClick={() => onChangeStep(item)}
							>
								{item.stepName}
							</li>
						))}
					</ul>
					{isAdmin() && adminDropdownItems?.length > 0 && (
						<div className={`dropdown old-menu-dropdowns ${isDropdownOpen ? 'show' : ''}`}>
							<Tooltip title="Old Menus" placement="top" arrow>
								<button
									className="btn btn-default dropdown-toggle"
									type="button"
									id="orderDetailsTabsMenu"
									aria-expanded={isDropdownOpen}
									onClick={() => setIsDropdownOpen((prev) => !prev)}
								>
									<img
										src="https://d1jlrnescmfthi.cloudfront.net/icons/more_icon.svg"
										alt="more"
									/>
								</button>
							</Tooltip>
							<ul
								className={`dropdown-menu dropdown-menu-right shadow-lg ${isDropdownOpen ? 'show' : ''}`}
							>
								{adminDropdownItems.map((item) => (
									<li
										key={item.workflowStep}
										className={`px-4 pb-3 ${currentStep === item.stepName ? 'selected' : ''}`}
										onClick={() => {
											onChangeStep(item);
											setIsDropdownOpen(false);
										}}
									>
										<span className="text-nowrap">{item.stepName} (Old)</span>
									</li>
								))}
							</ul>
						</div>
					)}
				</div>
			)}
		</>
	);
};

export default OrderDetailsTabs;
